/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Device_ForgetInputs */

const th_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลบออก`)
};

const en_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forget`)
};

const ja_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`削除`)
};

const zh_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除`)
};

const es_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olvidar`)
};

const pt_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esquecer`)
};

const id_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lupakan`)
};

const fr_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oublier`)
};

const tl_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalimutan`)
};

const vi_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quên`)
};

const ko_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`삭제`)
};

const de_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen`)
};

const ru_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Забыть`)
};

const tr_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaldır`)
};

const it_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi`)
};

const pl_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuń`)
};

const uk_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Забути`)
};

const hi_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हटाएँ`)
};

const ar_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إزالة`)
};

const ms_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lupakan`)
};

const bn_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সরান`)
};

const zh_tw2_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除`)
};

const zh_hk2_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除`)
};

const ur_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ہٹائیں`)
};

const fa_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حذف`)
};

const sw_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ondoa`)
};

const nl_device_forget = /** @type {(inputs: Device_ForgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwijderen`)
};

/**
* | output |
* | --- |
* | "Forget" |
*
* @param {Device_ForgetInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const device_forget = /** @type {((inputs?: Device_ForgetInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Device_ForgetInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_device_forget(inputs)
	if (locale === "ja") return ja_device_forget(inputs)
	if (locale === "zh") return zh_device_forget(inputs)
	if (locale === "es") return es_device_forget(inputs)
	if (locale === "pt") return pt_device_forget(inputs)
	if (locale === "id") return id_device_forget(inputs)
	if (locale === "fr") return fr_device_forget(inputs)
	if (locale === "tl") return tl_device_forget(inputs)
	if (locale === "vi") return vi_device_forget(inputs)
	if (locale === "ko") return ko_device_forget(inputs)
	if (locale === "de") return de_device_forget(inputs)
	if (locale === "ru") return ru_device_forget(inputs)
	if (locale === "tr") return tr_device_forget(inputs)
	if (locale === "it") return it_device_forget(inputs)
	if (locale === "pl") return pl_device_forget(inputs)
	if (locale === "uk") return uk_device_forget(inputs)
	if (locale === "hi") return hi_device_forget(inputs)
	if (locale === "ar") return ar_device_forget(inputs)
	if (locale === "ms") return ms_device_forget(inputs)
	if (locale === "bn") return bn_device_forget(inputs)
	if (locale === "zh-TW") return zh_tw2_device_forget(inputs)
	if (locale === "zh-HK") return zh_hk2_device_forget(inputs)
	if (locale === "ur") return ur_device_forget(inputs)
	if (locale === "fa") return fa_device_forget(inputs)
	if (locale === "sw") return sw_device_forget(inputs)
	if (locale === "nl") return nl_device_forget(inputs)
	return en_device_forget(inputs)
});